enum EInvoiceForwardAction {
  ACCEPT = 'ACCEPT', // Receiver accepts EInvoice Forward Request
  REJECT = 'REJECT', // Receiver rejects EInvoice Forward Request
  WITHDRAW = 'WITHDRAW', // Requestor/Receiver withdraws the request
}

export default EInvoiceForwardAction;
